import PropTypes from 'prop-types';
import { CardBottomContent as CardBottomContentBehavior } from '../extensions/constants/BehaviorTypes';
import { useBehavior } from '../extensions/hooks/useBehavior';
import { useAssociatedObjectsCardContentContext } from '../context/AssociatedObjectsCardContext';
import { jsx as _jsx } from "react/jsx-runtime";
const CardBottomContent = ({
  toObjectTypeId,
  fromObjectTypeId,
  fromObjectId,
  primaryDisplayLabel
}) => {
  const {
    hasScope,
    isUngated
  } = useAssociatedObjectsCardContentContext();
  const CardBottomContentComponent = useBehavior(CardBottomContentBehavior, toObjectTypeId, hasScope, isUngated);
  return /*#__PURE__*/_jsx(CardBottomContentComponent, {
    toObjectTypeId: toObjectTypeId,
    fromObjectTypeId: fromObjectTypeId,
    fromObjectId: fromObjectId,
    primaryDisplayLabel: primaryDisplayLabel
  });
};
CardBottomContent.propTypes = {
  fromObjectTypeId: PropTypes.string.isRequired,
  fromObjectId: PropTypes.number.isRequired
};
export default CardBottomContent;